import { useAppContext } from "contexts/AppContext";
import { useEffect, useState } from "react";
import useAxios from "./useAxios";

const useSync = (timeIntervals = 5 * 60) => {
  // contexts
  const { appState, setAppState } = useAppContext();

  // states
  const [syncInitial, setSyncInitial] = useState(null);
  const [syncTimer, setSyncTimer] = useState(null);
  const [queue, setQueue] = useState([]);

  // hooks
  const { loading, data, error, post, put } = useAxios();

  // functions
  const fire = (url, data) => {
    post(url, data);
  };

  const sync = () => {
    const orders = JSON.parse(localStorage.getItem("sales") || "[]");
    orders.sort((a, b) => (a.dId > b.dId ? 1 : -1));

    setQueue(
      orders.map((order) => ({
        id: order.id,
        sales_man: order.salesMan.id,
        doc_date: order.docDate,
        deliveryDate: order.deliveryDate,
        customer: order.customer.id,
        customer_branch: order.customerBranch?.id,
        customer_email: order.customerEmail,
        customerOrderNumber: order.customerPONumber,
        paymentTerms: order.paymentTerms.id,
        deliveryPoint: order.customerBranch?.address,
        terms: order.terms,
        labeling: order.labeling,
        remarks: order.remarks,
        draft: order.draft,
        customer_signature: order.customerSignature,
        sales_man_signature: order.salesmanSignature,
        details: order.details.map((cartItem) => ({
          id: cartItem.id,
          deliveryDate: order.deliveryDate,
          item: cartItem.item,
          quantity: cartItem.quantity,
          deliveryPoint: order.deliveryPoint,
          sales_price: cartItem.salesPrice,
          extra: !!cartItem.extra,
        })),
      }))
    );
  };

  const startSyncTimer = () => {
    let timer = timeIntervals;
    setAppState({
      key: "settings.autoSyncTime",
      value: timeIntervals,
    });
    setSyncTimer(
      setInterval(() => {
        if (timer > 0) {
          setAppState({
            key: "settings.autoSyncTime",
            value: timer - 1,
          });
          timer -= 1;
        } else {
          sync();
          timer = 300;
        }
      }, 1000)
    );
  };

  const autosyncChanged = (state) => {
    if (state === false) {
      if (syncInitial) clearTimeout(syncInitial);
      if (syncTimer) clearInterval(syncTimer);
      setAppState({
        key: "settings.autoSyncTime",
        value: 0,
      });
    } else {
      setSyncInitial(setTimeout(sync, 5 * 1000));
      startSyncTimer();
    }
  };

  // effects
  useEffect(() => {
    if (queue.length) {
      if (queue[0].id) put(`/sales/salesorders/${queue[0].id}/`, queue[0]);
      else post("/sales/salesorders/", queue[0]);
    }
  }, [queue]);

  useEffect(() => {
    if (!loading && data) {
      localStorage.setItem(
        "sales",
        JSON.stringify(queue.slice(1, queue.length))
      );
    }
    if (queue.length) setQueue(queue.slice(1, queue.length));
  }, [loading]);

  useEffect(() => {
    // autosyncChanged(appState.settings.autoSync);
    autosyncChanged(false);
  }, [appState.settings.autoSync]);
  return { sync };
};

export default useSync;
